module.exports = __webpack_public_path__ + "static/media/tlyfePRO.9033c618.svg";